import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Sparkles, Hourglass, LogOut, Layers } from "lucide-react";
import { MODULES } from "@/lib/modules";

/**
 * Pantalla genérica "Próximamente". La utilizamos para todos los módulos que
 * aún no han sido liberados (todo lo que no pertenezca al Hito 1).
 */
export default function ComingSoon({ moduleId, title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const mod = MODULES.find((m) => m.id === moduleId);

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen jasq-bg-playful flex items-center justify-center px-4 py-10" data-testid="coming-soon-page">
      <div className="jasq-blob bg-[#F5B82E]" style={{ width: 320, height: 320, top: -80, right: -60 }} />
      <div className="jasq-blob bg-[#D63384]" style={{ width: 260, height: 260, bottom: -60, left: -40, animationDelay: "1.5s" }} />

      <div className="relative z-10 w-full max-w-2xl jasq-card p-8 sm:p-10 text-center">
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-5"
              style={{ background: (mod?.color || "#F5B82E") + "1A", color: mod?.color || "#F5B82E" }}>
          {mod ? <Hourglass size={28} /> : <Sparkles size={28} />}
        </span>

        <p className="text-[11px] tracking-[0.2em] uppercase font-extrabold text-[#F5B82E]">
          Próximamente
        </p>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[#1F2547] mt-2">
          {title || (mod ? `${mod.id} · ${mod.name}` : "Módulo en preparación")}
        </h1>
        <p className="text-base text-[#4C5478] leading-relaxed mt-4 max-w-lg mx-auto">
          {user?.role === "estudiante" || user?.role === "docente" ? (
            <>Hola <span className="font-bold">{user?.name?.split(" ")[0]}</span>, estamos preparando con cariño tu experiencia. Por ahora la plataforma está habilitada únicamente para la gestión administrativa (Hito 1).</>
          ) : (
            <>Este módulo aún no está liberado. Forma parte de los próximos hitos del roadmap NEUROMATEMÁTICAS JASQ®.</>
          )}
        </p>

        <div className="mt-6 pt-6 border-t border-[#E1E5F0] text-left">
          <p className="text-[11px] uppercase tracking-wider font-extrabold text-[#6E7591] mb-3 flex items-center gap-2">
            <Layers size={14} /> Módulos liberados en el Hito 1
          </p>
          <div className="grid sm:grid-cols-3 gap-2">
            {MODULES.filter((m) => ["M1", "M10", "M14"].includes(m.id)).map((m) => {
              const Icon = m.icon;
              return (
                <div key={m.id} className="p-3 rounded-xl border-2 border-[#F5B82E] bg-[#FFF7DA] flex items-center gap-3">
                  <span className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0" style={{ background: `${m.color}1A`, color: m.color }}>
                    <Icon size={16} />
                  </span>
                  <div className="min-w-0">
                    <p className="font-bold text-sm text-[#1F2547] truncate">{m.id}</p>
                    <p className="text-[11px] text-[#6E7591] truncate">{m.short}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <button onClick={handleLogout} className="jasq-btn-ghost mt-6 inline-flex items-center gap-2" data-testid="coming-logout">
          <LogOut size={14} /> Cerrar sesión
        </button>
      </div>
    </div>
  );
}
